<template>
    <div id="previewPDF">
        <!--<van-popup v-model="params.showPdf" close-on-click-overlay="false" closeable="true" overlay="false">-->
        <div class="pdf-panel" v-show="params.showPdf">
            <div class="pdf-title"><a @click="params.showPdf = false">关闭</a></div>
            <iframe :src="params.data" class="iframe-panel" width="100%" height="100%">
            </iframe>
        </div>
        <!--</van-popup>-->
    </div>
</template>

<script>
    export default {
        name: "previewPDF",
        data() {
            return {}
        },
        props: {
            params: {
                type: Object,
                default() {
                    return {
                        showPdf: false
                    }
                }
            }
        },
        created() {
        },
        methods: {},
        watch: {
            params() {
            },
            show(newVal) {
                this.$emit('getpdfShow', newVal)
            }
        }
    }
</script>

<style lang="scss" scoped>
    #previewPDF {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
        .pdf-panel {
            height: 100%;
            .pdf-title {
                background: #4494f3;
                color: #fff;
                height: px2rem(115);
                font-size: px2rem(44);
                font-family: Arial;
                padding-right: 0.24rem;
                a {
                    float: right;
                    height:  px2rem(44);
                    line-height:  px2rem(115);
                }
            }
        }
    }
</style>